import React, { useEffect } from "react";
import { InputNumber } from "antd";
import PreviewQuestionLabel from "../../../common/PreviewQuestionLabel/PreviewQuestionLabel";
import { useSurveyInputStore } from "../../../../surveyStore";
import PreviewQuestionConstraints from "../../../common/PreviewQuestionConstraints/PreviewQuestionConstraints";
import useEvaluateConstraint from "../../question-preview/hooks/useEvaluateConstraint";

import "./Decimal.scss";

export const Decimal = React.memo(
   ({ props, hasErrors, surveyId, userId, submissionId, label, hint, defaultValue }) => {
      const { id, questionType, isRequired, answers } = props;

      const inputState = useSurveyInputStore((state) => state.inputs?.[id]);
      const setInputs = useSurveyInputStore((state) => state.setInputs);

      const hasSubmissionId = Boolean(submissionId);

      const submissionAnswer = submissionId
         ? answers?.find((answer) =>
              props.repeatInstanceIndex
                 ? answer?.answerDetail.repeatGroup === props.repeatInstanceIndex
                 : answer
           )?.answerDetail?.number
         : null;

      const value = hasSubmissionId ? submissionAnswer : inputState?.answerDetail?.number ?? null;

      const passConstraint = useEvaluateConstraint(
         !hasSubmissionId ? props.constraint : null,
         value
      );

      const showErrors =
         hasErrors && isRequired && (!inputState || inputState?.answerDetail?.number === null);

      const onChange = (e) => {
         if (submissionId) return;
         if (!e) {
            setInputs({
               target: {
                  name: id,
                  value: ""
               }
            });
         } else {
            setInputs({
               target: {
                  name: id,
                  value: {
                     surveyId: surveyId,
                     userId: userId,
                     questionId: id,
                     questionType: questionType,
                     name: props.name,
                     skipLogicAnswer: parseFloat(e),
                     answerDetail: {
                        number: parseFloat(e)
                     }
                  }
               }
            });
         }
      };

      useEffect(() => {
         if (defaultValue) {
            onChange(defaultValue);
         }
         // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [defaultValue]);

      return (
         <div className="decimal_number-submission-type-wrapper">
            <PreviewQuestionLabel label={label} isRequired={isRequired} hint={hint} />

            <InputNumber
               size="large"
               name={id}
               min={0}
               step="0.01"
               stringMode
               readOnly={hasSubmissionId}
               status={showErrors || (passConstraint !== null && !passConstraint) ? "error" : ""}
               placeholder={"Type your answer here"}
               value={value}
               onChange={onChange}
               prefixCls="decimal_number-submission-type-wrapper--decimal"
            />

            <span className="decimal_number-submission-type-wrapper--error">
               {showErrors ? "This field is required" : " "}
               {passConstraint !== null && !passConstraint ? (
                  <PreviewQuestionConstraints constraintMessages={props.constraintMessages} />
               ) : null}
            </span>
         </div>
      );
   }
);
